import { getDeviceConfiguration } from '../configuration/getDeviceConfiguration';
import { getPersonalListType } from '../configuration/utils';
import { createMissingInitRhinoError } from '../errors';

import { createMissingPersonalListTypeError } from './errors';
import { fetchPersonalLineupQuery } from './queries';

export async function fetchPersonalLineup() {
  const configuration = getDeviceConfiguration();

  if (!configuration) {
    throw createMissingInitRhinoError();
  }

  const listType = getPersonalListType(configuration);

  if (!listType) {
    throw createMissingPersonalListTypeError();
  }

  const personalLineup = await fetchPersonalLineupQuery({ listType });

  if (personalLineup?.allLineups.length) {
    return personalLineup;
  }
}
